import Button from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { Link } from 'react-router-dom';

const AdminPanelNavigator = () => {
  return (
    <div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 24 24"
              fill="#98A6C4">
              <path d="M19.43 12.98c.04-.32.07-.65.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.37-.3-.59-.22l-2.49 1a8.12 8.12 0 0 0-1.7-.98l-.38-2.65a.487.487 0 0 0-.48-.41h-4c-.24 0-.44.17-.48.41l-.38 2.65c-.63.27-1.21.6-1.7.98l-2.49-1a.503.503 0 0 0-.59.22l-2 3.46a.495.495 0 0 0 .12.64l2.11 1.65c-.05.32-.08.65-.08.98s.03.66.07.98l-2.11 1.65a.495.495 0 0 0-.12.64l2 3.46c.12.22.37.3.59.22l2.49-1c.53.38 1.1.71 1.7.98l.38 2.65c.04.24.24.41.48.41h4c.24 0 .44-.17.48-.41l.38-2.65c.63-.27 1.21-.6 1.7-.98l2.49 1c.23.09.47 0 .59-.22l2-3.46a.495.495 0 0 0-.12-.64l-2.11-1.65zm-7.43 2.02c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"></path>
            </svg>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem>
            <Link to={'/access-control-panel'}>Access control panel</Link>
          </DropdownMenuItem>
          {import.meta.env.VITE_DLMS_BASE_URL && (
            <DropdownMenuItem>
              <Link to={'/access-control-panel/dlms'}>
                DLMS access control panel
              </Link>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default AdminPanelNavigator;
